import axios from 'axios';

const API_URL = '/api/tags';

export interface PopularTag {
    id: number;
    name: string;
    postCount: number;
}

export const getPopularTags = async (limit: number = 20, token?: string | null) => {
    const response = await axios.get(`${API_URL}/popular`, {
        params: { limit },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return response.data as PopularTag[];
};
